export default "__VITE_ASSET__DD7KW1r6__"